import { onMounted, onUnmounted, Ref } from "vue";

interface ClickOutsideOptions {
  handler: (event: MouseEvent) => void;
  middleware?: (event: MouseEvent) => boolean;
}

export function useClickOutside(
  elements: Ref<HTMLElement | null>[],
  options: ClickOutsideOptions
) {
  const clickOutsideHandler = (event: MouseEvent) => {
    if (options.middleware && !options.middleware(event)) return;

    const isOutside = elements.every(
      (element) =>
        element.value && !element.value.contains(event.target as Node)
    );

    if (isOutside) {
      options.handler(event);
    }
  };

  onMounted(() => {
    document.addEventListener("click", clickOutsideHandler);
  });

  onUnmounted(() => {
    document.removeEventListener("click", clickOutsideHandler);
  });
}
